import {
	POST_WORK_CENTER,
	POST_WORK_CENTER_ERROR,
	POST_WORK_CENTER_SUCCESS,
} from '../../../constants';

export const postWorkCenterReducer = (state, actions) => {
	switch (actions.type) {
		case POST_WORK_CENTER:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case POST_WORK_CENTER_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case POST_WORK_CENTER_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				workCenters: actions.payload,
			};
		default:
			return state;
	}
};
